import { DataProvider } from 'react-admin';

import { dataProvider as dataProviderOld } from '../dataProvider';
import { resourceDataProviders } from './resourceDataProviders';

const getResourceDataProvider = (resourceDataProviders: Record<string, DataProvider>, resource: string): DataProvider =>
  resourceDataProviders[resource] || dataProviderOld;

const createDataProvider = (resourceDataProviders: Record<string, DataProvider>): DataProvider => {
  return {
    create: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).create(resource, params),
    delete: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).delete(resource, params),
    deleteMany: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).deleteMany(resource, params),
    getList: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).getList(resource, params),
    getMany: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).getMany(resource, params),
    getManyReference: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).getManyReference(resource, params),
    getOne: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).getOne(resource, params),
    update: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).update(resource, params),
    updateMany: async (resource, params) =>
      getResourceDataProvider(resourceDataProviders, resource).updateMany(resource, params),
  };
};

export const dataProvider = createDataProvider(resourceDataProviders);
